import { BOTTOM_BAR_ITEMS, visibleNavItems } from './nav-items';
import type { NavItemId } from './nav-items';
import type { User } from '../../types/user';

interface BottomTabBarProps {
  active: NavItemId;
  onNavigate: (id: NavItemId) => void;
  /** Whose tab bar it is — a screen they may not reach is not offered. */
  user: User;
}

/** Phone navigation: thumb-sized tabs pinned to the bottom of the screen. */
export function BottomTabBar({ active, onNavigate, user }: BottomTabBarProps) {
  const items = visibleNavItems(user, BOTTOM_BAR_ITEMS);
  if (items.length === 0) return null;

  return (
    <nav
      aria-label="ניווט ראשי"
      data-print="hide"
      className="lg:hidden print:hidden fixed bottom-0 inset-x-0 z-30 bg-panel border-t border-line pb-[env(safe-area-inset-bottom)]"
    >
      {/* The column count follows what this account can actually see, so a
          narrower role gets wider tabs rather than an empty slot. It is an
          inline style because the number is not known at build time and
          Tailwind only ships the classes it can read in the source. */}
      <ul
        className="grid"
        style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
      >
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = item.id === active;
          return (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => onNavigate(item.id)}
                aria-current={isActive ? 'page' : undefined}
                className={[
                  'w-full h-16 flex flex-col items-center justify-center gap-1 text-[10px]',
                  isActive ? 'text-brand-700 font-semibold' : 'text-ink/50',
                ].join(' ')}
              >
                <Icon size={20} aria-hidden />
                {item.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
